// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".price-table{min-width:25rem}.scroll-table{overflow-x:auto}\n", "",{"version":3,"sources":["/app/src/component/specific/booking/mobilePriceDetails/mobilePriceDetails.scss"],"names":[],"mappings":"AAAA,aACE,eAAgB,CACjB,cAEC,eAAgB","file":"mobilePriceDetails.scss","sourcesContent":[".price-table {\n  min-width: 25rem;\n}\n.scroll-table {\n  overflow-x: auto;\n}\n"]}]);
// Exports
module.exports = exports;
